import React from 'react';
import { IonChip, IonItem, IonLabel, IonText } from '@ionic/react';
import { UpcomingEvent } from '../../../models';
import { Ages } from '../../../utils/ages';

interface Props {
    event: UpcomingEvent;
}

const UpcomingEventRow: React.FC<Props> = ({ event }) => {
    const dateLabel = event.startDateTs
        ? new Ages(event.startDateTs).toFormat('dd mmm')
        : '';
    const dowLabel = event.startDateTs
        ? new Ages(event.startDateTs).toFormat('ddd')
        : '';

    return (
        <IonItem button detail routerLink={`/events/${event.uuid}`} className="upcoming-event-row">
            <div slot="start" className="upcoming-event-date">
                <IonText color="medium"><p className="dow">{dowLabel}</p></IonText>
                <IonText><p className="date">{dateLabel}</p></IonText>
            </div>
            <IonLabel>
                <h3>{event.name}</h3>
                <div className="upcoming-event-chips">
                    {event.packageSummary.map((pkg, idx) => (
                        <IonChip
                            key={`${event.id}-pkg-${pkg.packageId ?? 'guest'}-${idx}`}
                            color="primary"
                        >
                            {`${pkg.count}× ${pkg.packageName}`}
                        </IonChip>
                    ))}
                </div>
            </IonLabel>
        </IonItem>
    );
};

export default UpcomingEventRow;
